<template>
    <div v-if="visible && image">
        <div class="modal-backdrop">
        </div>
        <div class="modal">
            <div class="modal-header">
                <h4 class="modal-title">{{$t('components.bug-report.title')}}</h4>
                <button class="btn-close" @click="close">&times;</button>
            </div>
            <div class="modal-body">
                <div class="row" v-if="state === 'pending'">
                    <form @submit="submitForm">
                        <div class="col-sm-12 text-center">
                            <img :src="this.image" class="img-fluid"/>
                        </div>
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label>{{$t('components.bug-report.description')}}</label>
                                <textarea class="form-control form-control-sm" rows="5" v-model="description"
                                          maxlength="255"></textarea>
                                <span>{{description.length}} / 255 (max)</span>
                            </div>
                        </div>
                        <div class="col-sm-12 text-center">
                            <button class="btn btn-wellis-gold w-50 text-white">{{$t('btnSend')}}</button>
                        </div>
                    </form>
                </div>
                <div class="row" v-if="state === 'sending'">
                    <div class="col-lg-6 offset-lg-3 my-6 text-center">
                        <h1 class="">{{$t('components.bug-report.sending')}}</h1>
                        <figure class="text-center pt-6">
                            <img class="fa-spin" src="/img/loading.png" alt="in-progress" width="128" height="128">
                        </figure>
                        <p>{{$t('components.bug-report.sending-text')}}</p>
                    </div>
                </div>
                <div class="row" v-if="state === 'sent'">
                    <div class="col-lg-6 offset-lg-3 my-6 text-center">
                        <h1 class="">{{$t('components.bug-report.sent')}}</h1>
                        <figure class="text-center pt-6">
                            <img src="/img/check.png" alt="thank-you" width="128" height="128">
                        </figure>
                        <p>{{$t('components.bug-report.sent-text')}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {empty} from "@/helpers";

export default {
    name: "BugReport",
    props: {
        visible: Boolean,
        screenshot: HTMLElement
    },

    data() {
        return {
            image: null,
            description: "",
            state: "pending"
        }
    },

    methods: {
        close() {
            this.$emit('close');
            this.state = 'pending';
            this.description = '';
        },

        convert() {
            this.image = this.screenshot.toDataURL("image/png").replace("image/png", "image/octet-stream");
        },

        validate() {
            return new Promise((resolve, reject) => {
                const errors = [];
                if (empty(this.description)) {
                    errors.push(this.$t('validation.required', {field: this.$t('components.bug-report.description')}));
                } else {
                    if (this.description.length > 255) {
                        errors.push(this.$t('validation.maxLength', {field: this.$t('components.bug-report.description'), num: 255}));
                    }
                }

                if (errors.length > 0) {
                    reject(errors);
                } else {
                    resolve();
                }
            });
        },

        submitForm(e) {
            e.preventDefault();
            this.validate()
                .then(() => {
                    this.state = 'sending';
                    this.$backend.post('bug-report', {
                        lang: this.$store.getters['langStore/current'],
                        desc: this.description,
                        screenshot: this.image
                    }).then(() => this.state = 'sent')
                        .catch(() => {
                            this.$swal.fire({
                                icon: "error",
                                allowOutsideClick: false,
                                html: this.$t('whoops')
                            });
                        });
                })
                .catch(errors => {
                    this.$swal.fire({
                        icon: "error",
                        allowOutsideClick: false,
                        html: errors.join('<br>')
                    });
                })
        }
    },

    watch: {
        'visible': function (value) {
            if (value) {
                this.convert();
            } else {
                this.image = null;
            }
        }
    }
}
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99998;
}

.modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
    margin: 15px auto 15px auto;
    height: calc(100vh - 50px);
    width: calc(100vw - 60vw);
    z-index: 99999;
}

.modal-header,
.modal-footer {
    padding: 15px;
    display: flex;
}

.modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #b89453;
    justify-content: space-between;
}

.modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
}

.modal-body {
    position: relative;
    padding: 20px 10px;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100vh - 152px);
}

.btn-close {
    border: none;
    font-size: 36px;
    cursor: pointer;
    font-weight: bold;
    color: #b89453;
    background: transparent;
}

.img-fluid {
    width: 95%;
}

</style>

